<button
	[type]="buttonType()"
	[attr.aria-label]="translateTitle() ? (title() | translate: buttonTranslateParams()) : title()"
	[title]="translateTitle() ? (title() | translate: buttonTranslateParams()) : title()"
	[ngClass]="getButtonCSS()"
	[ngStyle]="buttonStyle()"
	[disabled]="(disabled() || showLoadingSpin()) && !showIconInLoadingSpin"
	(click)="clicked.emit(true)"
>
	@if (showLoadingSpin()) {
		<ng-container *ngTemplateOutlet="loadingSpin"></ng-container>
	} @else {
		@if (showIconOnly()) {
			<ng-container *ngTemplateOutlet="iconOnly"></ng-container>
		} @else {
			<ng-container *ngTemplateOutlet="iconAndText"></ng-container>
		}
	}
</button>

<ng-template #iconOnly>
	@if (iconClasses) {
		<i class="ico" [ngClass]="iconClasses" [ngStyle]="iconStyle()"></i>
	}
</ng-template>

<ng-template #loadingSpin>
	<stages-spin [size]="loadingSpinSize" [color]="loadingSpinColor" />
	@if (showIconInLoadingSpin) {
		<ng-container *ngTemplateOutlet="iconOnly" />
	}
</ng-template>

<ng-template #iconAndText>
	<ng-container *ngTemplateOutlet="iconOnly" />
	@if (translateTitle()) {
		<span [translate]="title()" [translateParams]="buttonTranslateParams()"></span>
	} @else {
		<span>{{ title() }}</span>
	}
</ng-template>
